import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Card,
  CardContent,
  makeStyles,
  colors,
  Icon,
  Avatar,
  Typography,
  Grid
} from '@material-ui/core';

import { MdEngineering } from "react-icons/md";

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const Toolbar = () => {

  const classes = useStyles();

  const [user, setUser] = useState({
    avatar: localStorage.getItem('avatar'),
    firstname: localStorage.getItem('firstname'),
    lastname: localStorage.getItem('lastname'),
    company: localStorage.getItem('company'),
    profile: localStorage.getItem('profile')
  });

  return (
    <Fragment>
      <Box mt={1}>
        <Card>
          <CardContent>
            <Box className={classes.baroperation}>

              <Grid container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item
                  md="auto"
                  xs="auto">
                  <Avatar variant="rounded"
                    className={classes.avatar}
                  >
                    {<Icon className={classes.iconoperation} component={MdEngineering} style={{ color: colors.indigo[400] }} ></Icon>}
                  </Avatar>

                </Grid>
                <Grid item
                  md="auto"
                  xs="auto">
                  <Typography
                    className={classes.name}
                    color="primary"
                    variant="h3"
                  >
                    Bem-vindo a operação <b>{user.company}</b>
                  </Typography>
                  <Typography
                    className={classes.name}
                    color="secondary"
                    variant="h4"
                  >
                    Você esta na área de <b>CONFIGURAÇÃO</b>, e tem acesso a todas as ações abaixo.
                  </Typography>

                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Fragment>

  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
